export default __webpack_public_path__ + "static/media/box.b25d008a.png";